// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d-wrapper[data-v-3a56ddb2] .app-loader{width:auto;height:100vh;position:relative;display:block;margin-top:200px}.label[data-v-3a56ddb2]{font-size:14px;margin-left:10px;margin-top:-3px;max-width:312px}.icon-info[data-v-3a56ddb2]{width:16px}.info-container[data-v-3a56ddb2]{display:flex;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
